import ModuleWrapper from 'shared-lib/containers/Module';

const Triggers = () => import(/* webpackChunkName: "triggers" */ '@/views/triggers/Triggers');
const AddTrigger = () => import(/* webpackChunkName: "triggers" */ '@/views/triggers/AddTrigger');
const CloneTrigger = () => import(/* webpackChunkName: "triggers" */ '@/views/triggers/CloneTrigger');
const EditTrigger = () => import(/* webpackChunkName: "triggers" */ '@/views/triggers/EditTrigger');
const TriggersDetails = () => import(/* webpackChunkName: "triggers" */ '@/views/triggers/TriggersDetails');
const meta = (data = {}) => ({
    permissionsModuleName: 'triggers',
    title: 'Triggers',
    auth: true,
    ...data,
});

export default [{
    path: 'triggers',
    component: ModuleWrapper,
    meta: meta({
        permission: 'list',
    }),
    children: [
        {
            path: '',
            name: 'Triggers',
            component: Triggers,
            meta: meta({
                permission: 'list',
            }),
        },
        {
            path: 'add',
            name: 'AddTrigger',
            component: AddTrigger,
            meta: meta({
                permission: 'create',
            }),
        },
        {
            path: ':triggerId(\\d+)/clone',
            name: 'CloneTrigger',
            component: CloneTrigger,
            props: true,
            meta: meta({
                permission: 'create',
            }),
        },
        {
            path: ':triggerId(\\d+)/edit',
            name: 'EditTrigger',
            component: EditTrigger,
            props: true,
            meta: meta({
                permission: 'update',
            }),
        },
        {
            path: ':triggerId(\\d+)',
            name: 'TriggerDetails',
            component: TriggersDetails,
            props: true,
            meta: meta({
                permission: 'list',
            }),
        },
    ],
}];
